
import React, { useState, useEffect } from 'react';
import { isDiagnosticsEnabled, isDevelopment } from './utils/diagnosticsUtils';

const DiagnosticsFooter: React.FC = () => {
  const [memoryUsage, setMemoryUsage] = useState<number | null>(null);
  const [sessionDuration, setSessionDuration] = useState<number>(0);
  
  useEffect(() => {
    // Only collect extended metrics if diagnostics are enabled
    if (!isDiagnosticsEnabled() && !isDevelopment()) return;
    
    // Record session start time
    const sessionStart = performance.now();
    
    // Update memory usage if performance API is available
    const updateMemoryUsage = () => {
      if ('memory' in performance) {
        setMemoryUsage((performance as any).memory.usedJSHeapSize / (1024 * 1024));
      }
      
      // Update session duration
      setSessionDuration((performance.now() - sessionStart) / 1000);
    };
    
    // Update metrics every 5 seconds
    const intervalId = setInterval(updateMemoryUsage, 5000);
    updateMemoryUsage(); // Initial update
    
    return () => clearInterval(intervalId);
  }, []);

  if (!isDiagnosticsEnabled() && !isDevelopment()) {
    return null;
  }

  return (
    <div className="mt-4 pt-2 border-t border-gray-200 dark:border-gray-700 text-[10px] text-gray-500">
      <div className="flex justify-between flex-wrap">
        <span>Environment: {process.env.NODE_ENV}</span>
        <span>Page: {window.location.pathname}</span>
        {memoryUsage !== null && (
          <span>Memory: {memoryUsage.toFixed(2)} MB</span>
        )}
        <span>Session: {sessionDuration.toFixed(1)}s</span>
      </div>
    </div>
  );
};

export default DiagnosticsFooter;
